import React from "react";
// Components
import VerifyToken from "../../config/verifyToken";
import { Main } from "../generalStyle";
import Header from "../../components/header";
import AddPatient from "../../components/addPatient";
import StickyLogo from "../../components/stickyLogo";

const PatientAdd = () => (
  <>
    {VerifyToken()}
    <Header />
    <Main>
      <StickyLogo />
      <AddPatient />
    </Main>
  </>
);

export default PatientAdd;
